import React from 'react';
import "./about.css";
import pbMeta from "./../../assets/Images/popbellymetaverse.png"
import {Helmet} from "react-helmet";


const RoadMap = () => {

  return (
    <>
      <div className='pt6 bg-black about pb3'>
        <Helmet>
          <title>Pop Belly NFT: Own your Favorite Heroes in the Metaverse</title>
        </Helmet>
        <div className="carousel" style={{display: "flex"}}>
          <img src={pbMeta} style={{margin: "auto"}} alt={"Own your Fav Heroes in the Metaverse"}/>
        </div>
        <div className='ph5 pt5 description w-100 flex white'>
          <div className="about-desc w-50 mr3">
            <h1>Briefly:</h1>
            <p>We are seeing a digital transformation of human communication
              and expression in the form of metaverses and NFTs. <br/><br/>

              A metaverse is a decentralized shared virtual space where
              everything is a digital asset or a Non-Fungible Token (NFT) with
              an associated value. This value is often kept in a cryptocurrency.<br/><br/>

              NFTs are digital assets that are often in the form of digital assets,
              they allow ownership of anything online, making the internet
              more personal and valuable.<br/><br/>

              Pop BeLLy is an NFT collection aimed at creating a strong
              community by offering its art. The art includes actors, villains,
              sportsmen, politicians, and other famous personalities.<br/><br/>

              Do you love any iconic individual? Messi or Ronaldo? Maybe Sachin
              Tendulkar and Shah Rukh Khan, the Indian cricketing, and acting gurus?.<br/><br/>

              Unlike other species, humans are very emotional beings. The best
              manifestations of human emotions are the love for your favorite
              human icons. People have heroes, idols, and icons because these
              successful individuals portray the best of human potential, they inspire,
              empower, and motivate people worldwide to follow their dreams<br/><br/>

              Your favorite hero may be a politician, sports star, entertainer, or any
              other person you like and want to be like when you grow up.
              Irrespective of their industries, all these individuals have one thing in
              common. They all have a strong fan following. Fans around the world
              show their love for their favorite icons in different ways.<br/><br/>

              Every fan has a unique manner of expressing his or her admiration for
              their hero. Fandoms and posts about cherished idols are often posted
              on social media platforms like Facebook, Twitter, or Reddit. For some,
              art is their medium of choice; they depict their heroes in a variety of
              mediums, from sketches to paintings. But there are also tales, fan
              fiction, and even comics or novels written about them.<br/><br/>

              No matter the medium you choose, love is a very personal expression.
              Have you ever imagined a space where you are representing your
              favorite hero or icon? Internet technology ushered a new era of
              information. What was formerly offline and confined to a certain set of
              individuals is now available online. You may express your feelings for
              someone online and have everyone recognize your human emotion and
              like.<br/><br/>

              The rapid emergence of blockchain technology has given birth to the
              new internet termed web3, which is backed by NFTs, blockchain games,
              and the Metaverse. This new iteration of the internet is revolutionizing
              digital asset ownership, empowering you to own what you post on the
              internet. Does that imply you can own your favorite icons as digital
              assets online?<br/><br/>

              To help you show your enthusiasm for something or someone in a
              more personal manner, we've written about how you can represent
              them in this age of digital ownership.<br/><br/>
            </p>
          </div>
          <div className="utility-desc w-50 ml3">
            <h1>Web3: Welcome to the New Internet</h1>
            <p>We are in the era of digital ownership, and it's here to stay. What was
              once a work of fiction is now a part of everyday life for millions of
              people throughout the world. An internet powered by NFTs,
              Metaverse, and blockchain technology is referred to as the Web3.<br/><br/>

              A non-fungible token is a digital asset that stores information stored in
              a smart contract on the blockchain associated with that cryptocurrency
              for the rest of its digital asset's existence.
              The NFTs are distinguished by the information contained inside them.
              No two NFTs can ever have the same amount of information. NFTs are
              used to verify ownership of anything that is posted on the internet.<br/><br/>

              People buy NFTs for two primary reasons. The first is art. Many people
              want to buy original art, and thanks to NFTs, they can now own original
              art and films. As a result, many billionaires and art enthusiasts buy NFTs
              from various marketplaces such as Opensea.
              Another reason people buy NFTs is to make money; excellent NFTs may
              provide a significant return if purchased early; for example, Bored Ape
              Yacht Club NFTs used to sell for a few dollars, but after NFTs gained
              popularity, they currently sell for millions.<br/><br/>

              What is the Metaverse and how do both NFTs and the Metaverse relate
              to online human expression?.<br/><br/>

              The name "metaverse" was invented by Neal Stephenson in his 1992
              science fiction book Snow Crash, although it has been trending for the
              last few years now. In his book, Stephenson described the metaverse as
              an enormous digital universe that coexists with the physical world.
              .<br/><br/>

              Metaverses may take on a variety of forms. While there are centralized
              metaverses, such as the one being built by Meta – once known as
              Facebook, and the one being developed by Microsoft, Minecraft's
              parent company, there are also decentralized metaverses, such as ours.
              In these innovative new virtual spaces, you may own anything you want
              without fear of duplication or piracy. As intended, metaverses are
              making the Internet more immersive and personalized.<br/><br/>

              Metaverse is primarily a move from text-based websites and controlled
              ecosystems to open virtual spaces featuring 3D elements where users
              may communicate via their avatars, that will be unique to each
              individual and shall have a digital signature.<br/><br/>
              The relationship between NFTs and Metaverses is the pinnacle of
              human creativity in recent years. Everything in the Metaverse is either a
              digital asset or a Non-Fungible Token (NFT). Due to the worth of NFTs,
              the metaverse restores value to the internet.<br/><br/>
              Because of the Metaverse and NFTs, human expression and experience
              may benefit from web3, which makes the internet more personal and
              immersive, while also helping to shape the future of communication.<br/><br/>
              Do you know there is an NFT collection offering heroes, villains,
              innovators, leaders, and role models as NFTs so you can use them as
              avatars in their Metaverse?
            </p>
          </div>
        </div>
        <div className='represent-dec ph5 pt5 w-100 flex white'>
          <h1>PoP BeLLy – The NFT Collection Allowing You to
            Represent Your Favorite Icon</h1>
          <p>
            The world has been blessed by many different sorts of individuals,
            including heroes, villains, inventors, leaders, and role models.
            PoP BeLLy is an NFT collection where you'll find a broad range of
            historical figures who have had a significant impact on the globe. Now
            you can own any of these heroes as digital art with help of this creative
            NFT art collection.<br/><br/>
            Pop BeLLy is available for purchase on both the OpenSea and Rarible
            marketplaces. You become a member of the Pop BeLLy's fantastic
            community after purchasing your hero from them.<br/><br/>
            The team behind the Pop Belly NFT collection is very dedicated to the
            project. The strength of the team is derived from their shared
            enthusiasm for the Metaverse and the drastic changes it will bring to
            our lives.<br/><br/>
            When you buy a Pop Belly, you will have a broad selection of classic
            characters to pick from. Those who pulverize pop cultural norms, those
            who enter the dragon's lair to vanquish evil or those who swallowed
            the red pill and sparked a revolution.
          </p>
        </div>
      </div>
      <div className='ph5 pt5 w-100 white'>
        <h1>Project Utility</h1>
        <p>
          Community is the king when it comes to joint virtual spaces such as the
          Metaverse. When you buy your favorite icon from Pop BeLLy art NFT
          collection, you enter a community of like-minded individuals. You get a
          community to whom you may express your preferences and connect
          with them.<br/><br/>
          One of the most rewarding outcomes of getting involved with Pop
          BeLLy is the development of a large and supportive community that will
          help you learn and grow as you go ahead into a virtual world that is
          about to undergo a major transformation.<br/><br/>
          As a result, the Pop Belly NFT project meets all the criteria and has the
          potential to be a standout in the NFT community. The collection's
          defining feature is its ability to develop a strong sense of community.
        </p>
      </div>
      <div className='ph5 pt5 w-100 white'>
        <h1>The Takeaway – Buy your own Pop BeLLy</h1>
        <p>
          We do not know yet where the Metaverse will take us or the
          opportunities that await us in this exciting new space where human
          expression, experience, and communication will see an unprecedented
          transformation.<br/><br/>
          What we do know is the NFTs and Metaverse are here to stay and they
          will allow us to be more personal and immersive on the internet, giving
          us the social freedom to be our true selves and perhaps our heroes, our
          favorite icons, or idols with PopBeLLy.
        </p>
      </div>
    </>
  );
};

export default RoadMap;